function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
import { property as l } from "../../node_modules/.pnpm/@lit_reactive-element@2.1.1/node_modules/@lit/reactive-element/decorators/property.js";
import { createRef as u } from "../../node_modules/.pnpm/lit-html@3.3.1/node_modules/lit-html/directives/ref.js";
import { KEY_CONSTANTS as m } from "../../consts/key-constants.js";
import { generateRandomId as _ } from "../../utils/string-utils.js";
import { TestableLitElement as v } from "../../utils/components/testable-lit-element/testable-lit-element.js";
import { handleDataTestid as c } from "../../utils/datatestid-utils.js";
import { getFirstFocusableElement as y } from "../../utils/accessibility-utils.js";
var T = Object.defineProperty,
  f = function f(h, e, i, o) {
    for (var t = void 0, s = h.length - 1, r; s >= 0; s--) (r = h[s]) && (t = r(e, i, t) || t);
    return t && T(e, i, t), t;
  };
var d = /*#__PURE__*/function (_v) {
  function d() {
    var _this;
    _classCallCheck(this, d);
    _this = _callSuper(this, d, arguments), _this.referenceId = "", _this.placement = "top-end", _this.xOffset = 0, _this.yOffset = 0, _this._tooltipRef = u(), _this._forceOpen = !1, _this._mousedInsideTooltip = !1, _this.tooltipId = _();
    return _this;
  }
  _inherits(d, _v);
  return _createClass(d, [{
    key: "firstUpdated",
    value: function firstUpdated() {
      var _this2 = this;
      if (this._tooltipRef.value && (this._tooltipRef.value.style.visibility = "hidden", this._tooltipRef.value.style.opacity = "0"), !this.referenceId) return;
      var e = this.referenceElement,
        i = this._tooltipRef.value;
      if (e && i) {
        var _e$shadowRoot;
        c(e, this.dataTestid, "trigger"), c(i, this.dataTestid, "tooltip");
        var o;
        (_e$shadowRoot = e.shadowRoot) !== null && _e$shadowRoot !== void 0 && _e$shadowRoot.delegatesFocus ? o = y(e) : o = e, o && (o.ariaDescribedByElements = [this]), e.addEventListener("mouseenter", function () {
          return _this2.showTooltip();
        }), e.addEventListener("mouseleave", function (t) {
          return _this2._handleMouseLeave(t, e, i);
        }), e.addEventListener("focusin", function () {
          return _this2.showTooltip();
        }), e.addEventListener("focusout", function () {
          return _this2.hideTooltip();
        }), i.addEventListener("mouseenter", function () {
          return _this2.showTooltip();
        }), i.addEventListener("mouseleave", function (t) {
          if (_this2._mousedInsideTooltip) {
            _this2.hideTooltip();
            return;
          }
          _this2._handleMouseLeave(t, e, i);
        }), document.addEventListener("keydown", function (t) {
          t.key === m.ESCAPE && (_this2._forceOpen = !1, _this2.hideTooltip());
        });
      }
    }
  }, {
    key: "referenceElement",
    get: function get() {
      var _document$querySelect;
      var e = document.querySelector("#".concat(this.referenceId));
      return e || (e = (_document$querySelect = document.querySelector("[data-id=\"".concat(this.referenceId, "\"]"))) === null || _document$querySelect === void 0 || (_document$querySelect = _document$querySelect.shadowRoot) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.querySelector("#".concat(this.referenceId))), e;
    }
  }, {
    key: "_handleMouseLeave",
    value: function _handleMouseLeave(e, i, o) {
      var t = i.getBoundingClientRect(),
        s = o.getBoundingClientRect(),
        r = this._isMouseInside(e, t, -5),
        n = this._isMouseInside(e, s, 25);
      !r && !n && this.hideTooltip(), n && (this._mousedInsideTooltip = !0);
    }
  }, {
    key: "_isMouseInside",
    value: function _isMouseInside(e, i) {
      var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var t = i.left,
        s = i.right,
        r = i.top,
        n = i.bottom,
        a = e.clientX,
        p = e.clientY;
      return a >= t - o && a <= s + o && p >= r - o && p <= n + o;
    }
  }, {
    key: "toggleTooltip",
    value: function toggleTooltip() {
      this._forceOpen = !this._forceOpen, this._forceOpen ? this.showTooltip() : this.hideTooltip();
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._cleanup && this._cleanup(), _superPropGet(d, "disconnectedCallback", this, 3)([]);
    }
  }, {
    key: "showTooltip",
    value: function showTooltip() {
      this.assignPosition(), this._tooltipRef.value && (this._tooltipRef.value.style.visibility = "visible", this._tooltipRef.value.style.opacity = "1");
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this._forceOpen || this._tooltipRef.value && (this._tooltipRef.value.style.visibility = "hidden", this._tooltipRef.value.style.opacity = "0");
    }
  }, {
    key: "assignPosition",
    value: function assignPosition() {}
  }]);
}(v);
f([l({
  attribute: "reference-id"
})], d.prototype, "referenceId");
f([l()], d.prototype, "placement");
f([l({
  type: Number,
  attribute: "x-offset"
})], d.prototype, "xOffset");
f([l({
  type: Number,
  attribute: "y-offset"
})], d.prototype, "yOffset");
export { d as NjcTooltip };